/**
 * Check if x value is between min and max value
 * @param {string} x item to check if in range
 * @param {number} min minimum range (inclusive)
 * @param {number} max maximum range (inclusive)
 * @returns {boolean}
 */
export const between = (x: string | number | null, min: number, max: number): boolean => {
  if (x !== null) {
    const value = typeof x === 'string' ? parseInt(x, 10) : x;

    return value >= min && value <= max;
  }
  return false;
};
